import React from "react"
import { Dispatch } from "redux"

import {
    QidModelOption,
    QidModelFailureMode,
} from "server/models"
import {
    setQidModelEditOption,
    setQidModelEditFailureMode,
    addModal,
} from "client/store"

import EditModel from "../editModel"
import EditSafetyFunction from "../editSafetyFunction"


export const openModel = (
    modelId: number,
    dispatch: Dispatch,
) => {
    dispatch(addModal({
        key: "editModel",
        content: <EditModel modelId={modelId} />,
    }))
}

export const openSafetyFunction = (
    modelId: number,
    safetyFunctionId: number,
    dispatch: Dispatch,
) => {
    dispatch(addModal({
        key: "editSafetyFunction",
        content: <EditSafetyFunction modelId={modelId} safetyFunctionId={safetyFunctionId} />,
    }))
}

export const openOption = (
    safetyFunctionId: number,
    option: QidModelOption,
    dispatch: Dispatch,
) => {
    dispatch(setQidModelEditOption({
        ...option,
        safetyFunctionId,
    }))
}

export const openFailureMode = (
    safetyFunctionId: number,
    failureMode: QidModelFailureMode,
    dispatch: Dispatch,
) => {
    dispatch(setQidModelEditFailureMode({
        ...failureMode,
        safetyFunctionId,
    }))
}
